var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, FieldText, FlexBox, FormField, FormGrid, Page, Text, } from '@dixa/lib-shared-habla';
import { config } from 'lib-shared-backend-config';
import noop from 'lodash/noop';
import moment from 'moment-timezone';
import { Field } from 'redux-form';
import { required } from 'redux-form-validators';
import { analytics } from 'app/utils/segment';
import { TimezoneSelector } from 'components/timezoneSelector';
import { dataUriToFile } from 'utils/file/dataUriToFile';
import AvatarControl from '../../../shared/avatarControl/components/AvatarControl';
import styles from './organization.module.scss';
export const Organization = (props) => {
    const handleSaveClick = (values) => {
        analytics.settingsOrganizationFormSubmitted();
        if (values) {
            const { name, timezone } = values.organization;
            const payload = {
                updates: {
                    name,
                },
                deletes: [],
            };
            if (props.hasTimezoneSetting) {
                if (timezone) {
                    payload.updates.timezone = timezone;
                }
                else {
                    payload.deletes.push('timezone');
                }
            }
            props.editOrganization(props.organization.id, payload);
        }
    };
    const handleAvatarSelect = (dataURI) => __awaiter(void 0, void 0, void 0, function* () {
        analytics.settingsOrganizationLogoChanged();
        const file = yield dataUriToFile(dataURI, 'avatar');
        props.updateAvatar(file, {
            id: props.organization.id,
        });
    });
    const { organization, pristine, submitting, invalid, handleSubmit, hasTimezoneSetting, } = props;
    return (_jsxs("form", Object.assign({ onSubmit: handleSubmit(handleSaveClick) }, { children: [_jsxs(Page.Section, Object.assign({ title: "Info", controls: _jsx(Button, Object.assign({ disabled: pristine || submitting || invalid, type: "submit" }, { children: "Save" })) }, { children: [_jsx(Box, Object.assign({ margin: "0 0 400 0" }, { children: _jsx(AvatarControl, { type: "org", user: organization, onSelectAvatar: handleAvatarSelect }) })), _jsxs(FormGrid, { children: [_jsx(FormField, Object.assign({ span: 3 }, { children: _jsx(Field, { label: "Name", name: "organization.name", component: FieldText, validate: [required()], required: true }) })), _jsx(FormField, Object.assign({ span: 3 }, { children: _jsx(FieldText, { label: "Dixa URL", input: {
                                        name: 'url',
                                        value: `https://${organization.subdomain}.${config.domain.web}`,
                                        onChange: noop,
                                    }, readOnly: true }) }))] })] })), hasTimezoneSetting && (_jsx(Page.Section, Object.assign({ title: "Preferences" }, { children: _jsx(FormGrid, { children: _jsx(FormField, Object.assign({ span: 3 }, { children: _jsx(Field, { component: TimezoneSelector, name: "organization.timezone", placeholder: `e.g. ${moment.tz.guess(true)}`, clearable: true, helpIcon: {
                                title: 'What is this?',
                                text: (_jsxs(FlexBox, Object.assign({ flexDirection: "column", gap: "300" }, { children: [_jsx(Text.Paragraph, Object.assign({ variant: "2", color: "white" }, { children: "Your organization\u2019s preferred timezone, which is used in the following places:" })), _jsxs(FlexBox, Object.assign({ flexDirection: "column", gap: "100" }, { children: [_jsx(Text.Heading, Object.assign({ variant: "heading-3", color: "white" }, { children: "Dashboard" })), _jsx(Text.Paragraph, Object.assign({ variant: "2", color: "white" }, { children: "Your dashboard metrics will reset each day at midnight in your chosen timezone." }))] }))] }))),
                                dark: true,
                                tooltipClassName: styles.timezoneTooltip,
                            } }) })) }) })))] })));
};
